export default "__VITE_ASSET__D1CZ78ga__"